import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSession } from './lib/session.jsx';
import { useTheme } from './lib/theme.jsx';
import { isNative } from './lib/supabase.js';
import { hideSplash, applyStatusBar } from './lib/native.js';
import { CrystalProvider } from './lib/crystalState.jsx';
import Layout from './components/Layout.jsx';
import Aurora from './components/Aurora.jsx';
import Landing from './pages/Landing.jsx';
import SignIn from './pages/SignIn.jsx';
import Dashboard from './pages/Dashboard.jsx';
import LiveStream from './pages/LiveStream.jsx';
import SubscriptionPage from './pages/Subscription.jsx';
import Profile from './pages/Profile.jsx';
import HealingMap from './pages/HealingMap.jsx';
import SettingsPage from './pages/Settings.jsx';
import AffiliatePage from './pages/Affiliate.jsx';

export default function App() {
  const { status } = useSession();
  const { theme } = useTheme();
  const native = isNative();

  // Native shell: the OS splash stays until we know who is signed in.
  useEffect(() => { if (status !== 'loading') hideSplash(); }, [status]);
  useEffect(() => { applyStatusBar(theme); }, [theme]);

  if (status === 'loading') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Aurora dim />
        <div className="relative h-10 w-10 rounded-full"
             style={{ background: 'conic-gradient(from 0deg, var(--clay), var(--sage), var(--apricot), var(--clay))',
                      animation: 'spin-slow 1.6s linear infinite', mask: 'radial-gradient(circle, transparent 55%, #000 58%)' }} />
      </div>
    );
  }

  if (status === 'anonymous') {
    // The marketing page is for the web; an installed app opens on sign-in.
    return (
      <Routes>
        <Route path="/"       element={native ? <SignIn /> : <Landing />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="*"       element={<Navigate to="/" replace />} />
      </Routes>
    );
  }

  return (
    <CrystalProvider>
      <Layout>
        <Routes>
          <Route path="/"             element={<Dashboard />} />
          <Route path="/map"          element={<HealingMap />} />
          <Route path="/ceremonies"   element={<LiveStream />} />
          <Route path="/subscription" element={<SubscriptionPage />} />
          <Route path="/profile"      element={<Profile />} />
          <Route path="/settings"     element={<SettingsPage />} />
          <Route path="/affiliate"    element={<AffiliatePage />} />
          <Route path="*"             element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </CrystalProvider>
  );
}
